<template>
  <div class="custom-classes-chooser-grade">
    <div class="header">
      <span class="title">年级</span>
    </div>
    <AppScrollbar class="main">
      <div class="grade-list">
        <ul>
          <li v-for="gradeName in gradeNames"
              :key="gradeName">
            <slot name="grade"
                  :label="gradeName">
              <a class="select-none theme-light-bg-hover theme-text-active theme-light-bg-active"
                 :class="{'is-active': gradeName === value}"
                 @click="selectGradeName(gradeName)">{{gradeName}}级</a>
            </slot>
          </li>
        </ul>
      </div>
    </AppScrollbar>
  </div>
</template>

<script>
import AppScrollbar from '../../../../../../../elements/AppScrollbar'
export default {
  name: 'CustomClassesChooserGrade',
  components: {
    AppScrollbar
  },
  props: {
    value: String,
    gradeNames: Array
  },
  methods: {
    selectGradeName (val) {
      this.$emit('input', val)
    }
  },
  watch: {
    gradeNames: {
      handler: function (vals) {
        if (vals && vals.length) {
          this.$emit('input', vals[0])
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss">
  .custom-classes-chooser-grade {
    display: flex;
    flex-direction: column;
    & > .header {
      flex: none;
      padding: 10px 15px;
      & > .title {
        color: #909399;
        font-size: 12px;
      }
    }
    & > .main {
      flex: auto;
      .grade-list {
        ul {
          margin: 0;
          padding: 0;
          list-style: none;
          & > li {
            a {
              display: block;
              color: #606266;
              font-size: 13px;
              padding: 5px 15px;
              line-height: 24px;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
</style>
